import React from 'react';
import { Link } from 'react-router-dom';

const RegisterPage: React.FC = () => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-blue-200">
    <div className="bg-white p-8 rounded-lg shadow-lg text-center">
      <h2 className="text-2xl font-bold mb-4">Create Your Account</h2>
      <p className="mb-6">Choose your account type to get started:</p>
      <div className="flex flex-col gap-4">
        <Link to="/auth/company-signup" className="btn btn-primary">
          I'm a Company
        </Link>
        <Link to="/auth/candidate-signup" className="btn btn-secondary">
          I'm a Candidate
        </Link>
      </div>
    </div>
  </div>
);

export default RegisterPage; 